"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsibilitiesApp = void 0;
var App_1 = require("../../App");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var contexts_1 = require("../../interfaces/contexts");
var api_1 = require("../../api");
var controlDialog_1 = require("../controls/controlDialog");
var filter_1 = require("./filter");
var riskTree_1 = require("../remap_ownership/riskTree");
var urls_1 = require("../../urls");
var ResponsibilitiesApp = (function (_super) {
    __extends(ResponsibilitiesApp, _super);
    function ResponsibilitiesApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onAddRiskClicked = function () {
            var project_id = App_1.store.responsibility.filter.data.current_project;
            window.history.pushState(null, null, window.location.href);
            window.location.replace((0, urls_1.resolve)(urls_1.Urls.risk_add_new, project_id));
        };
        return _this;
    }
    ResponsibilitiesApp.prototype.onClickRisk = function (risk) {
        var url = (0, urls_1.resolve)(urls_1.Urls.risk_detail, risk.risk.project_id, risk.risk.id);
        var search = window.location.search;
        window.open(url + search);
    };
    ResponsibilitiesApp.prototype.onClickControl = function (control) {
        var project_id = parseInt(control.control.project_id);
        App_1.store.context.set(new contexts_1.ProjectContext(project_id));
        api_1.api.projects.id(project_id).controls.id(control.control.id).get().then(function (control) {
            App_1.store.controlDialog.openDialog(control);
        });
    };
    ResponsibilitiesApp.prototype.onClickAction = function (action) {
        show_action(action.action.id, parseInt(action.action.project_id));
    };
    ResponsibilitiesApp.prototype.onAddControlClicked = function (riskParent) {
        App_1.store.context.set(new contexts_1.RiskContext(parseInt(riskParent.risk.project_id), riskParent.risk.id));
        App_1.store.controlDialog.openDialog(null);
    };
    ResponsibilitiesApp.prototype.onAddActionClicked = function (controlParent) {
        open_new_action_dialog(controlParent.control.project_id, controlParent.control.id.toString());
    };
    ResponsibilitiesApp.prototype.render = function () {
        var project_id = App_1.store.responsibility.filter.data.current_project;
        var current_group = App_1.store.responsibility.filter.data.current_group;
        var context = App_1.store.context.get();
        var updatingResults = App_1.store.responsibility.data.isUpdating;
        var project_name = "";
        if (App_1.store.responsibility.filter.data.projects) {
            project_name = App_1.store.responsibility.filter.data.projects.filter(function (value) { return value.value === current_group.toString(); }).map(function (value) { return value.display_name; })[0];
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("h1", null, gettext("Responsibilities")),
            project_name && React.createElement("h2", { className: "my-3" }, project_name),
            updatingResults &&
                React.createElement("div", { className: "iconwrapper" },
                    React.createElement("i", { className: "fas fa-spinner fa-spin tabSpinner statusTab" })),
            React.createElement("div", { className: "rounded px-3 pb-4 pt-1" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-12" },
                        React.createElement(filter_1.ResponsibilityFilter, { filter: App_1.store.responsibility.filter.data, isUpdating: App_1.store.responsibility.filter.isUpdating, addRiskClickHandler: project_id ? this.onAddRiskClicked : null }))),
                React.createElement("div", { className: "row mt-2" },
                    React.createElement("div", { className: "col-12" },
                        React.createElement("div", { id: "risk_tree" },
                            React.createElement(riskTree_1.RiskTree, { key: "responsibility", ownerships: App_1.store.responsibility.data.data, showCheckboxes: false, filterElements: false, addNodeIcon: true, onClickRisk: this.onClickRisk, onClickControl: this.onClickControl, onClickAction: this.onClickAction, onAddControlClicked: this.onAddControlClicked, onAddActionClicked: this.onAddActionClicked })))),
                React.createElement("div", null, context instanceof contexts_1.ProjectContext &&
                    React.createElement(controlDialog_1.ControlDialog, { isOpen: App_1.store.controlDialog.isOpen, control: App_1.store.controlDialog.control, applied_tags: App_1.store.controlDialog.applied_tags, available_tags: App_1.store.controlDialog.available_tags, recurrence: App_1.store.controlDialog.recurrence, comments: App_1.store.controlDialog.comments, relations: App_1.store.controlDialog.relations, causality_relations: App_1.store.controlDialog.causality_relations, references: App_1.store.controlDialog.references, entries: App_1.store.controlDialog.entries, availableStatuses: App_1.store.controlDialog.availableStatuses, availableOwners: App_1.store.controlDialog.availableOwners, availableRecurrence: App_1.store.controlDialog.availableRecurrence, controlCosts: App_1.store.controlDialog.controlCosts, availableRiskTargets: App_1.store.controlDialog.availableRiskTargets, udf_types: App_1.store.controlDialog.udf_types, udf_section_header: App_1.store.controlDialog.udf_section_header, onSubmit: function () {
                            window.location.reload();
                        } })))));
    };
    ResponsibilitiesApp = __decorate([
        mobx_react_1.observer
    ], ResponsibilitiesApp);
    return ResponsibilitiesApp;
}(React.Component));
exports.ResponsibilitiesApp = ResponsibilitiesApp;
